module.exports = __webpack_public_path__ + "static/media/r2.039b15c9.png";